import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Truck } from "lucide-react";
import { PLATFORMS } from "@/data/catalog";

/**
 * Dialog "Livraison bientôt disponible".
 * Active Uber Eats / Deliveroo dès qu'un `url` est renseigné dans catalog.js.
 */
export const DeliveryDialog = ({ trigger }) => (
  <Dialog>
    <DialogTrigger asChild>
      {trigger || (
        <button
          type="button"
          data-testid="delivery-trigger"
          className="font-street inline-flex items-center justify-center gap-2 rounded-md border border-[#F5EFE6]/20 bg-[#F5EFE6]/[0.04] px-5 py-3 text-sm tracking-wider text-[#F5EFE6] hover:border-[#F5EFE6]/40 hover:bg-[#F5EFE6]/[0.08] transition-colors"
        >
          <Truck size={16} className="text-[#C9A875]" />
          Livraison
        </button>
      )}
    </DialogTrigger>
    <DialogContent className="bg-[#0F0F0F] border border-[#262626] text-white max-w-md">
      <DialogHeader>
        <DialogTitle className="font-street text-2xl tracking-wide">
          Livraison bientôt disponible
        </DialogTitle>
        <DialogDescription className="text-sm text-[#D4D4D8] leading-relaxed">
          La livraison sera prochainement disponible via Uber Eats et Deliveroo.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-2 pt-2">
        {PLATFORMS.map((p) => {
          const active = p.status === "active" && p.url;
          const content = (
            <>
              <span
                className="font-street text-base tracking-wider"
                style={{ color: p.color }}
              >
                {p.name}
              </span>
              <span className="text-[10px] uppercase tracking-[0.22em] text-white/55 font-street">
                {active ? "Commander" : "Bientôt disponible"}
              </span>
            </>
          );
          return active ? (
            <a
              key={p.id}
              href={p.url}
              target="_blank"
              rel="noreferrer"
              data-testid={`delivery-${p.id}`}
              className="flex items-center justify-between gap-2 rounded-lg border border-[#262626] bg-[#0A0A0A] px-4 py-3 hover:border-white/30"
            >
              {content}
            </a>
          ) : (
            <div
              key={p.id}
              aria-disabled="true"
              data-testid={`delivery-${p.id}`}
              className="flex items-center justify-between gap-2 rounded-lg border border-[#1F1F1F] bg-[#0A0A0A] px-4 py-3 opacity-80 cursor-not-allowed"
            >
              {content}
            </div>
          );
        })}
      </div>
      <p className="text-[11px] italic text-white/45 leading-snug pt-2">
        En attendant, vous pouvez préparer votre commande sur le site et appeler
        directement le restaurant.
      </p>
    </DialogContent>
  </Dialog>
);

export default DeliveryDialog;
